import { Suspense, useMemo } from "react";
import { Route, Routes, matchPath, useLocation } from "react-router-dom";
import { GENERAL_ROUTES, GUEST_ROUTES } from "utils/routes.constants";

import { useAppVersionUpdateNotification } from "hooks/useAppVersionUpdateNotification";
import { ThemeProvider } from "themes/themeContext";

import { LoginHandle } from "pages/Auth/LoginHandle/LoginHandle";

import FakePageLoader from "./FakePageLoader";
import { Layout } from "./Layout";

import styles from "./styles.module.scss";

const AppInner: React.FC = () => {
  useAppVersionUpdateNotification();
  const location = useLocation();

  const isGuestRoute = useMemo(() => {
    const guestRoutes = [
      ...Object.values(GUEST_ROUTES),
      ...Object.values(GENERAL_ROUTES),
    ];

    for (let i = 0; i < guestRoutes.length; i++) {
      const match = matchPath(guestRoutes[i], location.pathname);
      if (match) {
        return true;
      }
    }

    return false;
  }, [location.pathname]);

  return (
    <ThemeProvider forcedTheme={isGuestRoute ? "light" : undefined}>
      <Suspense
        fallback={
          <div className={styles.layout}>
            <FakePageLoader title="Loading data..." />
          </div>
        }
      >
        <LoginHandle>
          <Routes>
            <Route
              path="*"
              element={<Layout />}
            />
          </Routes>
        </LoginHandle>
      </Suspense>
    </ThemeProvider>
  );
};

export default AppInner;
